import { PaygoLandPlanId, PaygoLandPlanName, PaygoSeaPlanName } from "./constant";
import { unauth } from "./globalConfig";

// Helpers to persist cart products in sessionStorage so they survive page navigations
const CART_STORE_KEY = 'itp_cartProductsStore';
const getCartStore = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CART_STORE_KEY) || '[]');
    } catch { return []; }
};
const setCartStore = (products) => {
    try {
        sessionStorage.setItem(CART_STORE_KEY, JSON.stringify(products));
    } catch { /* ignore */ }
};

export const resetCartStore = () => {
    try { sessionStorage.removeItem(CART_STORE_KEY); } catch { /* ignore */ }
};



export const dispatchPageView = (currentPage, pageDetail, selector, mtnDetailList) => {


    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
            && !(typeof vzdl.page.name === 'undefined' || vzdl.page.name === null)) {
            vzdl.page.name = currentPage;
            vzdl.page.flow = "intl itp";
            vzdl.page.throttle = "nsa 1.0";
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "pageView",
                params: {
                    data: {
                        page: {
                            detail: typeof pageDetail !== "undefined" && pageDetail,
                        }
                    }

                }
            });
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "openView",
                params: {
                    selector: selector, 
                    name: typeof pageDetail !== "undefined" && pageDetail,
                    trackAs: "none"
                }
            });
        }
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
            && !(typeof vzdl.page.detail === 'undefined' || vzdl.page.detail === null)) {
            vzdl.page.detail = "";
        }
        if (currentPage === "ITP_DestinationSelection" || currentPage === "ITP_Traveldates") {
            if ((!(typeof vzdl === 'undefined' || vzdl === null))
            && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
            && !(typeof vzdl.txn.product === 'undefined' || vzdl.txn.product === null)
            && !(typeof vzdl.txn.product.owns === 'undefined' || vzdl.txn.product.owns === null)) {
            vzdl.txn.product.owns = [];

            mtnDetailList && mtnDetailList?.map((item, id) => {

                vzdl.txn.product.owns.push(
                    {
                        "name": item?.nickName,
                        "model": item?.modelName,
                        "skuId": item?.skuId,
                        "category": "Device",
                        "mtn": item?.mtn,
                        "role": item?.role,
                    }
                )

                item?.itpPlanDetails.map((currentPlan) => {
                    let cost = currentPlan.planCost && currentPlan.planCost.split('/') ? currentPlan.planCost.split('/')[0] : currentPlan.planCost;
                    vzdl.txn.product.owns.push(
                        {
                            "name": currentPlan?.planName,
                            "id": currentPlan?.planId,
                            "planType": currentPlan?.planType,
                            "recurringPrice": cost,
                        }
                    )
                })
                if (item?.itpPlanDetails.length === 0) {
                    vzdl.txn.product.owns.push(
                        {
                            "name": PaygoLandPlanName,
                            "id": PaygoLandPlanId,
                            "category": "Plan",
                            "recurringPrice": "-",
                        },
                        {
                            "name": PaygoSeaPlanName,
                            "id": "",
                            "category": "Plan",
                            "recurringPrice": "-",
                        }
                    )
                }
            })        
        }
        }
    }
    catch (ex) { console.error(ex); }
}

// export const dispatchConfirmationPageView= (currentPage) => {
//     try {
//         if (!(typeof vzdl === 'undefined' || vzdl === null)
//             && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
//             && !(typeof vzdl.page.name === 'undefined' || vzdl.page.name === null)) {
//             vzdl.page.name = currentPage;
//             vzdl.page.throttle = "nsa 1.0";
//         }
//         if (!(typeof window.VZTAG_IS_READY === 'undefined' || window.VZTAG_IS_READY === null) && window.VZTAG_IS_READY) {
//             vztag.api.dispatch("pageView", {});
//         } else {
//             document.addEventListener("vztagReady", function () {
//                 window.vztag.api.dispatch("pageView", {});
//             });
//         }
//     }
//     catch (ex) { }
// }

export const dispatchVzdlEvent = (eventName) => {
    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.event === 'undefined' || vzdl.event === null)
            && !(typeof vzdl.event.value === 'undefined' || vzdl.event.value === null)) {
            vzdl.event.value = eventName;
        }    }
    catch (ex) { console.error(ex); }
}
export const setModelTagging= (title, id, opened) => {

    if (opened) {
        setOpenModel(title, id);
        setModalName(title);
    }
    else {
        setCloseModel(title, id);
        setModalName("");
    }
}
export const setOpenModel = (title, elementId) => {
    try {
        if (window.vztag) {
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "openView",
                params: {
                    selector: elementId,
                    name: title
                }
            });        }
    } catch (ex) { console.error(ex); }
}
export const setCloseModel= (title, elementId) => {
    try {
        if (window.vztag) {
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "closeView",
                params: {
                    selector: elementId,
                    name: title
                }
            });        }
    } catch (ex) { console.error(ex); }
}
export const setModalName= (currentPage) => {

    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
            && !(typeof vzdl.page.detail === 'undefined' || vzdl.page.detail === null)) {
            vzdl.page.detail = currentPage;
        }    }
    catch (ex) { console.error(ex); }
}


export const dispatchError= (errMsgDisplayed) => {
    try {
        if (window.vztag) {

            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "error",
                params: {
                    message: errMsgDisplayed
                }
            });
        }    
    } 
    catch (ex) { console.error(ex); }
}



export const dispatchNotifyEvent= (name, errorCode, message) => {
    try {
        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "notify",
            params: {
                name: name,
                message: message,                
                error: errorCode == "99" ? true : false,
            }
        });
    } catch (ex) {
        console.error(ex);
    }
}

export const dispatchAddToCart = (planDetails, prevPageName) => {
    try {        // Only include features where a new plan was actually selected (not "keep current plan")
        const newProducts = planDetails?.featuresCart
            ?.map((feature, index) => ({ feature, index }))
            ?.filter(({ feature, index }) => {
                const updatedPlan = planDetails?.updatedPlanDetails?.[index];
                return feature?.newPlanId && updatedPlan?.currentPlan !== true;
            })
            ?.map(({ feature, index }) => {
                const updatedPlan = planDetails?.updatedPlanDetails?.[index];
                let rawCost = feature.planCost || updatedPlan?.planCost;
                let cost = rawCost && rawCost.split('/') ? rawCost.split('/')[0] : rawCost;
                return {
                    name: feature?.newPlanName || feature?.planName || "",
                    id: feature?.newPlanId || "",
                    category: feature?.newPlanCategory || feature?.planType || "Plan",
                    discount: "",
                    line: planDetails?.mtnHashCode || "",
                    merchCat: "product",
                    offer: "",
                    qty: "1",
                    sku: feature?.newPlanId || "",
                    shared: "N",
                    nonRecurringPrice: "",
                    recurringPrice: cost || "",
                };
            }) || [];        // Remove any previously stored products for the same mtn lines, then add the new ones
        const newLines = newProducts.map(p => p.line);
        const existingProducts = getCartStore().filter(p => !newLines.includes(p.line));
        const allProducts = [...existingProducts, ...newProducts];
        setCartStore(allProducts);        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
            && !(typeof vzdl.txn.product === 'undefined' || vzdl.txn.product === null)) {
            vzdl.txn.product.add = allProducts;
        }

        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "addToCart",
            params: {
                openCart: false,
                prevPageName: prevPageName || "",
                product: allProducts,
            }
        });
    } catch (ex) {
        console.error(ex);
    }
}

export const dispatchProductTracker = (name, event, products) => {
    try {
        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "productTracker",
            params: {
                name: name,
                events: event, // comma delimit multiple events                
                products: products
            }
        });
    } catch (ex) {
        console.error(ex);
    }
}

const checkUpdatePlanStatus = (deviceInfo, confirmedPlanData, failedUpdateCartData) => {

    if (confirmedPlanData.some(plan => (plan.mtn === deviceInfo?.mtn))) {
        return "Updated"
    } else if (failedUpdateCartData.some(plan => (plan.mtn === deviceInfo?.mtn))) {
        return "Error"
    } else {
        return ""
    }
}
const getDeviceAndPlansImpression = (deviceInfoData, confirmedPlanData, failedUpdateCartData) => {
    const deviceDetails = [];
    deviceInfoData.map((device) => {
        deviceDetails.push({
            "type": device.role,
            "status": checkUpdatePlanStatus(device, confirmedPlanData, failedUpdateCartData)
        })
    })
    const combinedDevices = deviceDetails.map((d) => `${d.type}|${d.status}`).join('|^');
    return {
        "impression": `||||||${combinedDevices}`,
        "updatedLines": deviceDetails.filter((d) => d.status === "Updated"),
        "failedLines": deviceDetails.filter((d) => d.status === "Error"),
    } 


}

const getPlanChangesDetails = (confirmedPlanData) => {
    return confirmedPlanData && confirmedPlanData.map((line, id) => {
        return line?.featuresCart.map((d) => `${d.currentPlanName ? d.currentPlanName : ""}|${d.newPlanName ? d.newPlanName : ""}`).join('^')
    }).join('^')
}
export const dispatchDeviceAndPlansImpression = (deviceInfoData, confirmedPlanData, failedUpdateCartData) => {
    try {
        const lineDetails = getDeviceAndPlansImpression(deviceInfoData, confirmedPlanData, failedUpdateCartData);
        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "impression",
            params: {
                list: lineDetails.impression,
            }
        });

        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null) && !(typeof vzdl.txn.planChanges === 'undefined' || vzdl.txn.planChanges === null)) {
            vzdl.txn.planChanges = getPlanChangesDetails(confirmedPlanData);
        }
    } catch (ex) {
        console.error(ex);
    }
}

/**
 * Sets the Adobe Analytics event string in vzdl.event.value.
 * @param {string} eventName - Comma-separated Adobe event IDs (e.g., "event116,purchase,event84")
 */
export const setPageEvent = (eventName) => {
    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.event === 'undefined' || vzdl.event === null) && !(typeof vzdl.event.value === 'undefined' || vzdl.event.value === null)) {
            vzdl.event.value = eventName;
        }
    } catch (ex) {
        console.error(ex);
    }
}

/**
 * Sets the page name in vzdl and fires the pageView hit via vztag.api.dispatch.
 * Must always be called LAST after all other tagging setup.
 * @param {string} currentPage - Page name string (e.g., 'ITP_confirmation')
 */
export const setPageView = (currentPage) => {
    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
            && !(typeof vzdl.page.name === 'undefined' || vzdl.page.name === null)) {
            vzdl.page.name = currentPage;
        }
        if (!(typeof window.VZTAG_IS_READY === 'undefined' || window.VZTAG_IS_READY === null) && window.VZTAG_IS_READY) {
            vztag.api.dispatch("pageView");
        } else {
            document.addEventListener("vztagReady", function () {
                window.vztag.api.dispatch("pageView");
            });
        }    } catch (ex) {
        console.error(ex);
    }
}

export const setConfimedPlanDetail= (confirmationData,selector) => {

    let successProducts = [];
    let failedProducts = [];
    let deviceDetails = confirmationData?.deviceDetails;
    if (!(typeof vzdl === 'undefined' || vzdl === null)
        && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
        && !(typeof vzdl.txn.product === 'undefined' || vzdl.txn.product === null)
        && !(typeof vzdl.txn.product.current === 'undefined' || vzdl.txn.product.current === null)) {
        vzdl.txn.id = confirmationData?.orderNumber ?? "";
        vzdl.txn.autoPay = '';
        vzdl.txn.orderType = 'intl';
        vzdl.txn.offer = '';
        vzdl.txn.discountId = '';
        vzdl.txn.paymentType = "";
        vzdl.txn.recurringCharges = "";
        vzdl.txn.discount = "";
        vzdl.txn.product.current = [];
       


        deviceDetails && deviceDetails.map((line, id) => {

              line?.currentPlanDetails.map((currentPlan) => {
                // Skip plans where planUpdated is undefined — these are "keep current plan" and should not appear in any products list
                if (currentPlan.planUpdated === undefined) return;
                let cost = currentPlan.planCost && currentPlan.planCost.split('/') ? currentPlan.planCost.split('/')[0] : currentPlan.planCost;
                if (currentPlan.planUpdated === true) {
                    successProducts.push({
                        "name": currentPlan?.planName,
                        "id": currentPlan?.planId,
                        "merchCat": "",
                        "category": "PLAN",
                        "offer": "",
                        "discount": "",
                        "qty": "1",
                        "recurringPrice": cost,
                        "nonRecurringPrice": "",
                        "line": line?.mtnHashCode,
                        "sku": "",
                        "contractType": "",
                        "shippingCharge": "",
                        "shippingType": "",
                        "shared": "",
                        "propId": "",
                        "path": "",
                        "group": id + 1,
                        "action": "",
                        "orderType": "INTL",
                    })
                } else if (currentPlan.planUpdated === false) {
                    // planUpdated explicitly false = plan update was attempted but failed
                    failedProducts.push({
                        "name": currentPlan?.planName,
                        "id": currentPlan?.planId,
                        "merchCat": "",
                        "category": "PLAN",
                        "offer": "",
                        "discount": "",
                        "qty": "1",
                        "recurringPrice": cost,
                        "nonRecurringPrice": "",
                        "line": line?.mtnHashCode,
                        "sku": "",
                        "contractType": "",
                        "shippingCharge": "",
                        "shippingType": "",
                        "shared": "",
                        "propId": "",
                        "path": "",
                        "group": id + 1,
                        "action": "",
                        "orderType": "INTL",
                    })
                }

            })
        })
        vzdl.txn.product.current = successProducts;
    }
    if (!(typeof vzdl === 'undefined' || vzdl === null)
        && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
        && !(typeof vzdl.txn.numberOfLines === 'undefined' || vzdl.txn.numberOfLines === null)) {
        //No of lines updated
        vzdl.txn.numberOfLines = deviceDetails.filter((line) => line.planUpdated).length ? deviceDetails.filter((line) => line.planUpdated).length : "0";
    }
    setPageEvent("event116,event171,event113,purchase,event84,event9");

    try {
        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "purchase",
            params: {
                products: successProducts
            }        });
    } catch (ex) {
        console.error(ex);
    }
    setPageView(unauth ? 'ITP_ReviewAndSignin' : 'ITP_confirmation');
    if (successProducts.length > 0) {
        dispatchProductTracker("ITP Product success", "event407", successProducts);
    }
    if (failedProducts.length > 0) {
        dispatchProductTracker("ITP Product failure", "event408", failedProducts);
    }


}
const combinedValues = (currentPlanDetails, key) => {
    if (key === "planCost") {
        return currentPlanDetails?.map(plan => {
            let cost = plan.planCost && plan.planCost.split('/') ? plan.planCost.split('/')[0] : plan.planCost;
            return cost;
        }).join('|');
    } else {
        return currentPlanDetails?.map(plan => plan[key]).join('|');
    }

}
export const setCurrentPlanDetails = (deviceData, selector, pageDetail) => {

    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.user === 'undefined' || vzdl.user === null)
            && !(typeof vzdl.user.numberOfLines === 'undefined' || vzdl.user.numberOfLines === null)) {
            //No of lines on account
            vzdl.user.numberOfLines = deviceData.length
        }
        if ((!(typeof vzdl === 'undefined' || vzdl === null))
            && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
            && !(typeof vzdl.txn.product === 'undefined' || vzdl.txn.product === null)
            && !(typeof vzdl.txn.product.owns === 'undefined' || vzdl.txn.product.owns === null)) {
            let planList = [];
            vzdl.txn.product.owns = [];

            deviceData && deviceData.map((item, id) => {

                vzdl.txn.product.owns.push(
                    {
                        "name": item?.deviceNickName,
                        "skuId": item?.skuId,
                        "category": "Device",
                        "mtn": item?.mtn,
                        "role": item?.role,
                    }
                )

                item?.currentPlanDetails.map((currentPlan) => {
                    let cost = currentPlan.planCost && currentPlan.planCost.split('/') ? currentPlan.planCost.split('/')[0] : currentPlan.planCost;
                    vzdl.txn.product.owns.push(
                        {
                            "name": currentPlan?.planName,
                            "id": currentPlan?.planId,
                            "category": currentPlan?.category,
                            "recurringPrice": cost,
                        }
                    )
                })
                if (item?.currentPlanDetails.length === 0) {
                    vzdl.txn.product.owns.push(
                        {
                            "name": "-",
                            "id": "-",
                            "category": "Plan",
                            "recurringPrice": "-",
                        }
                    )
                }            
            })
        }
        dispatchPageView('ITP_DeviceandplansSelection', pageDetail, selector);
    }
    catch (ex) { console.error(ex); }
}


